// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3gUUa","emails":"CreateEditClinics_emails__1HCVe","emailTagLabel":"CreateEditClinics_emailTagLabel__PuBtF"};